import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { Paginated, PaginationQuery } from "../../types";
import useApi, { buildUrl } from "../api";
import { CustomError } from "../errors";
import { Packaging, SearchPackagingResponse, UpsertPackaging } from "./types";

const usePackagingApi = () => {
  const baseurl = "/packagings";

  const api = useApi();

  const searchPackagings = useCallback(() =>
    // query: PaginationQuery
    {
      //   const url = api.buildUrl(`${baseurl}`, query);
      const url = baseurl;
      const data = api.get<SearchPackagingResponse>({ url });
      return data;
    }, [api]);

  const usePackagings = useCallback(
    (query: PaginationQuery) => {
      const url = buildUrl(baseurl, query);
      const result = useQuery<Paginated<Packaging>, CustomError>({
        queryKey: [url],
        queryFn: ({ signal }) => api.get<Paginated<Packaging>>({ url, signal }),
      });
      return { ...result, error: result.error ?? undefined };
    },
    [api]
  );

  const createPackaging = useCallback(
    async (p: UpsertPackaging) => {
      const data = await api.post<UpsertPackaging, string>(baseurl, p);
      api.mutateCache([baseurl]);
      return data;
    },
    [api]
  );

  const updatePackaging = useCallback(
    async (s: UpsertPackaging, packagingID: string) => {
      const data = await api.put<UpsertPackaging>(`${baseurl}/${packagingID}`, s);
      api.mutateCache([baseurl]);
      return data;
    },
    [api]
  );

  const deletePackaging = useCallback(
    async (packagingID: string) => {
      const data = await api.del(`${baseurl}/${packagingID}`);
      api.mutateCache([baseurl]);
      return data;
    },
    [api]
  );

  return {
    searchPackagings,
    usePackagings,
    createPackaging,
    updatePackaging,
    deletePackaging,
  };
};

export default usePackagingApi;
